import React from 'react';
import styled from 'styled-components';

import { BaseArrowBack } from '../../svg';
import { NavigationButton } from '../NavigationButton';

interface IProps {
    backgroundGrey?: boolean;
    className?: string;
    helpText: string;
    onClick?(): void;
}

const BaseBackButton: React.FC<IProps> = ({ className, ...props }) => (
    <NavigationButton className={className} {...props}>
        <BaseArrowBack />
    </NavigationButton>
);

export const BackButton = styled(BaseBackButton)``;
